import { Widget } from "@exopengithub/exokit";
import clsx from "clsx";
import type { ComponentProps } from "react";

// WHY: min-h-48 keeps a sparse widget from shrinking its row; min-w-0 keeps long content from widening its grid column.
export const DASHBOARD_WIDGET_MIN_SIZE = "min-h-48 min-w-0";

/**
 * Base for every dashboard widget's view — same exokit Widget, with the
 * shared minimum size applied so widgets never fall below a filler's size
 * regardless of which widget ends up sharing its row.
 *
 * IMPORTANT: every dashboard widget view must render through this, not
 * import Widget from exokit directly — see dashboardWidgetBase.test.ts,
 * which fails the build if one doesn't. This is also the one place a future
 * "customize the dashboard" feature (drag handle, resize grip, remove
 * button) gets added — once, here, not per widget.
 */
export const DashboardWidgetBase = ({
	className,
	...props
}: ComponentProps<typeof Widget>) => (
	<Widget className={clsx(DASHBOARD_WIDGET_MIN_SIZE, className)} {...props} />
);
